// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RedebitModel from '../../model/redebit-model';
import RedebitDTO from '../dto/redebit-dto';
import dtoSchema from '../schemas/redebit-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class RedebitModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RedebitDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.transactionId = data.transactionId;
      this.endToEndId = data.endToEndId ?? undefined;
      this.amount = data.amount;
      this.currency = data.currency ?? undefined;
      this.entryDate = data.entryDate;
      this.debtorName = data.debtorName ?? undefined;
      this.debtorAddress = data.debtorAddress ?? undefined;
      this.debtorZipCode = data.debtorZipCode ?? undefined;
      this.debtorCity = data.debtorCity ?? undefined;
      this.debtorCountry = data.debtorCountry ?? undefined;
      this.uploadIntegrationCallId = data.uploadIntegrationCallId ?? undefined;
      this.uploadStatus = data.uploadStatus ?? undefined;
      this.uploadStatusResponse = data.uploadStatusResponse ?? undefined;
      this.uploadStatusReportDownloadDate = data.uploadStatusReportDownloadDate ?? undefined;
      this.paymentIntegrationCallId = data.paymentIntegrationCallId ?? undefined;
      this.paymentRecivedDate = data.paymentRecivedDate ?? undefined;
      this.paymentStatus = data.paymentStatus ?? undefined;
      this.paymentStatusResponse = data.paymentStatusResponse ?? undefined;
      this.paymentStatusReportDownloadDate = data.paymentStatusReportDownloadDate ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int32}
  */
  transactionId?: number;
  /**
  */
  endToEndId?: string;
  /**
  * @type {double}
  */
  amount?: number;
  /**
  */
  currency?: string;
  /**
  * @type {date-time}
  */
  entryDate?: string;
  /**
  */
  debtorName?: string;
  /**
  */
  debtorAddress?: string;
  /**
  */
  debtorZipCode?: string;
  /**
  */
  debtorCity?: string;
  /**
  */
  debtorCountry?: string;
  /**
  * @type {int64}
  */
  uploadIntegrationCallId?: number;
  /**
  * @type {int32}
  */
  uploadStatus?: number;
  /**
  */
  uploadStatusResponse?: string;
  /**
  * @type {date-time}
  */
  uploadStatusReportDownloadDate?: string;
  /**
  * @type {int32}
  */
  paymentIntegrationCallId?: number;
  /**
  * @type {date-time}
  */
  paymentRecivedDate?: string;
  /**
  */
  paymentStatus?: string;
  /**
  */
  paymentStatusResponse?: string;
  /**
  * @type {date-time}
  */
  paymentStatusReportDownloadDate?: string;

  static toModel(dto: DeepPartial<RedebitDTO>): RedebitModel;
  static toModel(dto: DeepPartial<RedebitDTO> | undefined | null): RedebitModel | undefined;
  static toModel(dto: DeepPartial<RedebitDTO> | undefined | null): RedebitModel | undefined {
    return dto ? new RedebitModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RedebitModel> | RedebitModel): RedebitDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      transactionId: unwrapped.transactionId,
      endToEndId: unwrapped.endToEndId,
      amount: unwrapped.amount,
      currency: unwrapped.currency,
      entryDate: unwrapped.entryDate,
      debtorName: unwrapped.debtorName,
      debtorAddress: unwrapped.debtorAddress,
      debtorZipCode: unwrapped.debtorZipCode,
      debtorCity: unwrapped.debtorCity,
      debtorCountry: unwrapped.debtorCountry,
      uploadIntegrationCallId: unwrapped.uploadIntegrationCallId,
      uploadStatus: unwrapped.uploadStatus,
      uploadStatusResponse: unwrapped.uploadStatusResponse,
      uploadStatusReportDownloadDate: unwrapped.uploadStatusReportDownloadDate,
      paymentIntegrationCallId: unwrapped.paymentIntegrationCallId,
      paymentRecivedDate: unwrapped.paymentRecivedDate,
      paymentStatus: unwrapped.paymentStatus,
      paymentStatusResponse: unwrapped.paymentStatusResponse,
      paymentStatusReportDownloadDate: unwrapped.paymentStatusReportDownloadDate,
    } as RedebitDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RedebitModel, can not map to RedebitDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
